import React, {useMemo} from 'react';
import {EllipsisText, FlexColumnSection, FlexRowSection, SmallText} from "../../../styles/globalStyles";
import {useSelector} from "react-redux";
import dayjs from "dayjs";
import {t} from "i18next";
import {DB_DATE_FORMAT} from "@arboxappv4/shared/src/constants/constants";
import orderBy from "lodash-es/orderBy";
import {getAttendanceDisplay, getSeriesEventsDaysText} from "../../../helpers/functions";
import {getDisabledPagesCourseProps} from "@arboxappv4/shared/src/helpers/DisablePages";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";

const TrackDescription = ({track}) => {
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const {isMobile} = useScreenSize()
    const sortedRelations = useMemo(
        () => orderBy(track?.series_track_relations ?? [], [relation => relation?.series?.series_name ?? '']),
        [track],
    );

    if (!track || !globalLocation) return <></>

    return (
        <FlexColumnSection gap={'20px'}>
            <div>
                <SmallText weight={'bold'}>{t('header-tracks')}: </SmallText>
                <div>{track.name}</div>
            </div>
            {track.bio &&
                <div>
                    <SmallText weight={'bold'}>{t('description')}: </SmallText>
                    <div style={{flex: 1, whiteSpace: 'pre-wrap'}}>{track.bio}</div>
                </div>
            }
            {track.session_per_week &&
                <div>
                    <SmallText weight={'bold'}>{t('session-per-week')}</SmallText>
                    <div>{t('frequency-track-label', {frequency: track.session_per_week})}</div>
                </div>
            }
            {(track.start_date || track.end_date) &&
                <FlexColumnSection flex={'unset'}>
                    <SmallText weight={'bold'}>{t('track-days-header')}</SmallText>
                    {track.start_date &&
                        <div>{t('starts-at', {start: dayjs(track.start_date, DB_DATE_FORMAT).format(globalLocation.date_format), interpolation: {'escapeValue': false}})}</div>
                    }
                    {track.end_date &&
                        <div>{t('ends-at', {end: dayjs(track.end_date, DB_DATE_FORMAT).format(globalLocation.date_format), interpolation: {'escapeValue': false}})}</div>
                    }
                </FlexColumnSection>
            }
                        {sortedRelations.length > 0 &&
                <FlexColumnSection flex={'unset'}>
                    <SmallText weight={'bold'}>{t('courses-included-in-track')}:</SmallText>
                    <FlexColumnSection flex={'unset'}>
                        {sortedRelations.map(relation => {
                            const series = relation.series
                            if (!series) return null
                            const daysText = getSeriesEventsDaysText(series?.series_events)
                            const displayProps = getDisabledPagesCourseProps(series)
                            const attendanceDisplay = getAttendanceDisplay(displayProps, series)
                            return (
                                <FlexRowSection key={`track-course-${series.id}`} gap={'8px'} align={'center'}>
                                    <span>{`${series.series_name}${daysText ? ` - ${daysText}` : ''}`}</span>
                                    {((displayProps.showNumRegistered || displayProps.showNumOpenSpots) && !series.isHugFull) &&
                                        <EllipsisText isMobile={isMobile} width={'80px'}>
                                            <FlexRowSection gap={'8px'}>
                                                <FontAwesomeIcon icon={solid('user')} color={Colors.siteBlack} size={'xs'}/>
                                                <span>{attendanceDisplay}</span>
                                            </FlexRowSection>
                                        </EllipsisText>}
                                </FlexRowSection>
                            )
                        })}
                    </FlexColumnSection>
                </FlexColumnSection>
            }
        </FlexColumnSection>
    );
};

export default TrackDescription;
